import { tokens } from 'styling/tokens'

interface IMachineCategoryIconProps {
  color?: string
  size?: number
}

const stroke = (color?: string) => color || tokens.accent.base

export const ExcavatorCategoryIcon = ({ color, size = 20 }: IMachineCategoryIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='3.5' y='15.5' width='10' height='4.5' rx='2.25' stroke={stroke(color)} strokeWidth='1.5' />
    <path d='M5.5 15.5V11h5.5v4.5' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M9.5 11.8 14.5 6.5l4.3 4.3' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M18.8 10.8l-.4 3.4-3-.9' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

export const HaulTruckCategoryIcon = ({ color, size = 20 }: IMachineCategoryIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M3.5 13.5V8.8l9 1.3v3.4z' stroke={stroke(color)} strokeWidth='1.5' strokeLinejoin='round' />
    <path d='M12.5 10.1h4.3' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
    <path d='M13.8 13.5v-2h2.6l1.9 2' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M3.5 13.5h16.5' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
    <circle cx='7' cy='16.3' r='2.2' stroke={stroke(color)} strokeWidth='1.5' />
    <circle cx='16' cy='16.3' r='2.2' stroke={stroke(color)} strokeWidth='1.5' />
  </svg>
)

export const ArticulatedDumpTruckCategoryIcon = ({ color, size = 20 }: IMachineCategoryIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M3.5 13.5V10h3.6l1.8 2.2v1.3z' stroke={stroke(color)} strokeWidth='1.5' strokeLinejoin='round' />
    <circle cx='10.3' cy='12.9' r='.8' fill={stroke(color)} />
    <path d='M11.8 13.5v-2l8.7-1.4v3.4z' stroke={stroke(color)} strokeWidth='1.5' strokeLinejoin='round' />
    <circle cx='6' cy='16.3' r='1.9' stroke={stroke(color)} strokeWidth='1.5' />
    <circle cx='13.8' cy='16.3' r='1.9' stroke={stroke(color)} strokeWidth='1.5' />
    <circle cx='18.2' cy='16.3' r='1.9' stroke={stroke(color)} strokeWidth='1.5' />
  </svg>
)

export const BulldozerCategoryIcon = ({ color, size = 20 }: IMachineCategoryIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='3.5' y='14.5' width='11.5' height='5' rx='2.5' stroke={stroke(color)} strokeWidth='1.5' />
    <circle cx='6.5' cy='17' r='.8' fill={stroke(color)} />
    <circle cx='9.25' cy='17' r='.8' fill={stroke(color)} />
    <circle cx='12' cy='17' r='.8' fill={stroke(color)} />
    <path d='M5.5 14.5V10h6.5v4.5' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M8 10V8' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
    <path d='M12 12.5h6.8' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
    <path d='M18.8 10.3c1.4 1.7 1.4 6.6 0 8.3' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
  </svg>
)

export const WheelLoaderCategoryIcon = ({ color, size = 20 }: IMachineCategoryIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M4 14.5V10h5.5v4.5' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M9.5 12.7h3.2l2 1.6' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M10.8 11.3 16 13.6' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
    <path d='M16.2 12.6l3.9 1.1v2.9l-4.6.2z' stroke={stroke(color)} strokeWidth='1.5' strokeLinejoin='round' />
    <circle cx='7' cy='16.6' r='2.1' stroke={stroke(color)} strokeWidth='1.5' />
    <circle cx='13.6' cy='16.6' r='2.1' stroke={stroke(color)} strokeWidth='1.5' />
  </svg>
)

export const MotorGraderCategoryIcon = ({ color, size = 20 }: IMachineCategoryIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M3.5 14V9.5h6.8V14' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M10.3 10.2h5.2l3.2 3.8' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M13.8 12.4v2.8' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
    <path d='M11.6 17.2l5-3' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
    <circle cx='5.6' cy='16.2' r='1.9' stroke={stroke(color)} strokeWidth='1.5' />
    <circle cx='9.4' cy='16.2' r='1.9' stroke={stroke(color)} strokeWidth='1.5' />
    <circle cx='18.4' cy='16.2' r='1.9' stroke={stroke(color)} strokeWidth='1.5' />
  </svg>
)

export const CompactorRollerCategoryIcon = ({ color, size = 20 }: IMachineCategoryIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='6.8' cy='15.2' r='3.7' stroke={stroke(color)} strokeWidth='1.5' />
    <circle cx='6.8' cy='15.2' r='.9' fill={stroke(color)} />
    <path d='M10.5 12.4h2.3' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
    <path d='M12.8 16.8V9.8h3.5l2.9 3.4v3.6' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <circle cx='16.4' cy='16.7' r='2.2' stroke={stroke(color)} strokeWidth='1.5' />
  </svg>
)

export const DrillRigCategoryIcon = ({ color, size = 20 }: IMachineCategoryIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='3.5' y='15.5' width='10' height='4.5' rx='2.25' stroke={stroke(color)} strokeWidth='1.5' />
    <path d='M5.5 15.5V12h6.5v3.5' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M11.8 12.8l4.3-3.4' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
    <path d='M16.6 4.5v13M19.4 4.5v13' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
    <path d='M16.6 4.5h2.8M16.6 8h2.8M16.6 11.5h2.8M16.6 15h2.8' stroke={stroke(color)} strokeWidth='1.3' strokeLinecap='round' />
    <path d='m16.9 18.3 1.1 1.9 1.1-1.9' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

export const MobileCraneCategoryIcon = ({ color, size = 20 }: IMachineCategoryIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M3.5 14.2h11.3v3.3H3.5z' stroke={stroke(color)} strokeWidth='1.5' strokeLinejoin='round' />
    <path d='M5.2 14.2v-2.4h4v2.4' stroke={stroke(color)} strokeWidth='1.5' strokeLinejoin='round' />
    <path d='M6.8 11.8 17.8 5' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
    <path d='M17.8 5v4.4' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
    <path d='M19 9.4a1.2 1.2 0 1 1-2.4 0' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
    <circle cx='6.8' cy='19' r='1.5' stroke={stroke(color)} strokeWidth='1.5' />
    <circle cx='12.2' cy='19' r='1.5' stroke={stroke(color)} strokeWidth='1.5' />
  </svg>
)

export const WaterTruckCategoryIcon = ({ color, size = 20 }: IMachineCategoryIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='3' y='9.5' width='10.8' height='5.8' rx='2.9' stroke={stroke(color)} strokeWidth='1.5' />
    <path d='M8.4 10.6c-1 1.1-1.5 1.9-1.5 2.6a1.5 1.5 0 0 0 3 0c0-.7-.5-1.5-1.5-2.6Z' stroke={stroke(color)} strokeWidth='1.3' strokeLinejoin='round' />
    <path d='M14.8 15.3v-4.2h2.7l2.7 2.9v1.3' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <circle cx='6.3' cy='17' r='1.8' stroke={stroke(color)} strokeWidth='1.5' />
    <circle cx='10.6' cy='17' r='1.8' stroke={stroke(color)} strokeWidth='1.5' />
    <circle cx='17' cy='17' r='1.8' stroke={stroke(color)} strokeWidth='1.5' />
  </svg>
)

export const FuelTruckCategoryIcon = ({ color, size = 20 }: IMachineCategoryIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='3' y='9.5' width='10.8' height='5.8' rx='2.9' stroke={stroke(color)} strokeWidth='1.5' />
    <path d='M6.9 9.5v5.8M10.4 9.5v5.8' stroke={stroke(color)} strokeWidth='1.3' />
    <path d='M8.65 9.5V8.2' stroke={stroke(color)} strokeWidth='1.3' strokeLinecap='round' />
    <path d='M14.8 15.3v-4.2h2.7l2.7 2.9v1.3' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <circle cx='6.3' cy='17' r='1.8' stroke={stroke(color)} strokeWidth='1.5' />
    <circle cx='10.6' cy='17' r='1.8' stroke={stroke(color)} strokeWidth='1.5' />
    <circle cx='17' cy='17' r='1.8' stroke={stroke(color)} strokeWidth='1.5' />
  </svg>
)

export const ServiceTruckCategoryIcon = ({ color, size = 20 }: IMachineCategoryIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M3.5 15.3V12h10v3.3' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M5.8 12V9.7h3.4V12' stroke={stroke(color)} strokeWidth='1.4' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M6.8 9.7v-.4a.7.7 0 0 1 1.4 0v.4' stroke={stroke(color)} strokeWidth='1.3' strokeLinecap='round' />
    <path d='M14.8 15.3v-4.2h2.7l2.7 2.9v1.3' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <circle cx='6.3' cy='17' r='1.8' stroke={stroke(color)} strokeWidth='1.5' />
    <circle cx='17' cy='17' r='1.8' stroke={stroke(color)} strokeWidth='1.5' />
  </svg>
)

export const LightVehicleCategoryIcon = ({ color, size = 20 }: IMachineCategoryIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M3.5 15.4v-3.5h7.6V9.2h4.4l2.3 2.7h2.7v3.5' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M12.9 11.9V9.9' stroke={stroke(color)} strokeWidth='1.3' strokeLinecap='round' />
    <path d='M3.5 15.4h1.7M9.2 15.4h5.4M18.6 15.4h1.9' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
    <circle cx='7.2' cy='15.7' r='1.9' stroke={stroke(color)} strokeWidth='1.5' />
    <circle cx='16.6' cy='15.7' r='1.9' stroke={stroke(color)} strokeWidth='1.5' />
  </svg>
)

export const BusCategoryIcon = ({ color, size = 20 }: IMachineCategoryIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='3.5' y='6' width='17' height='11' rx='2' stroke={stroke(color)} strokeWidth='1.5' />
    <path d='M3.5 10.8h17' stroke={stroke(color)} strokeWidth='1.5' />
    <path d='M8.2 6v4.8M12.8 6v4.8' stroke={stroke(color)} strokeWidth='1.3' />
    <path d='M16.8 10.8V17' stroke={stroke(color)} strokeWidth='1.3' />
    <circle cx='7.5' cy='17.8' r='1.7' fill={stroke(color)} />
    <circle cx='16.5' cy='17.8' r='1.7' fill={stroke(color)} />
  </svg>
)

export const GeneratorCategoryIcon = ({ color, size = 20 }: IMachineCategoryIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='4' y='6.5' width='16' height='11.5' rx='1.6' stroke={stroke(color)} strokeWidth='1.5' />
    <path d='M7.2 18v1.8M16.8 18v1.8' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
    <path d='M13.4 8.7l-3.8 4.6h3l-1.6 4 4.2-5h-3z' stroke={stroke(color)} strokeWidth='1.4' strokeLinejoin='round' />
  </svg>
)

export const TowerLightCategoryIcon = ({ color, size = 20 }: IMachineCategoryIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='8' y='4' width='8' height='3.6' rx='.9' stroke={stroke(color)} strokeWidth='1.5' />
    <path d='M12 4v3.6' stroke={stroke(color)} strokeWidth='1.3' />
    <path d='M9.3 8.8l-1 1.8M14.7 8.8l1 1.8' stroke={stroke(color)} strokeWidth='1.3' strokeLinecap='round' />
    <path d='M12 7.6V17' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
    <path d='M12 17l-4.2 3.2M12 17l4.2 3.2' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
    <path d='M9.9 18.6h4.2' stroke={stroke(color)} strokeWidth='1.3' strokeLinecap='round' />
  </svg>
)

export const DefaultMachineCategoryIcon = ({ color, size = 20 }: IMachineCategoryIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='12' cy='12' r='4.2' stroke={stroke(color)} strokeWidth='1.5' />
    <circle cx='12' cy='12' r='1.1' fill={stroke(color)} />
    <path d='M12 5.5v2.3M12 16.2v2.3M5.5 12h2.3M16.2 12h2.3M7.4 7.4 9 9M15 15l1.6 1.6M16.6 7.4 15 9M9 15l-1.6 1.6' stroke={stroke(color)} strokeWidth='1.5' strokeLinecap='round' />
  </svg>
)
